<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="  overflow: auto; padding-bottom: 53px"
  >
    <template slot="title">
      <div style="width: 100%">
        <span>{{ title }}</span>
        <span
          style="display: inline-block; width: calc(100% - 51px); padding-right: 10px; text-align: right"
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height: 20px; width: 20px; border: 0px"
          ></a-button>
        </span>
      </div>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" :colon="false">
        <a-form-item
          label="姓名："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select placeholder="请选择" v-model="view.name">
            <a-select-option
              v-for="item in selectData"
              :key="item.id"
              :value="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="职务："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="20"
            type="text"
            placeholder="请输入"
            v-model="view.duties"
          />
        </a-form-item>
        <a-form-item
          label="证书："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-checkbox-group v-model="view.certificate">
            <a-checkbox value="1">基金从业资格证</a-checkbox>
            <a-checkbox value="2">证券从业资格证</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item
          label="投资观点："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            placeholder="请输入"
            :auto-size="{ minRows: 2, maxRows: 6 }"
            v-model="view.investment"
          />
        </a-form-item>
        <a-form-item
          label="头像："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-image-upload
            file-type="file"
            accept=".jpg, .png"
            text="上传"
            fileKey="picFile"
            v-decorator="['portrait']"
            url="wechatwork-groupchat-biz/wechatwork/wechatMsg/upFile"
            @getFileList="
              fileList => {
                _getFileList(fileList, 'portrait');
              }
            "
          >
          </j-image-upload>
        </a-form-item>
        <a-form-item
          label="微信二维码："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-image-upload
            file-type="file"
            accept=".jpg, .png"
            text="上传"
            fileKey="picFile"
            v-decorator="['qrCode']"
            url="wechatwork-groupchat-biz/wechatwork/wechatMsg/upFile"
            @getFileList="
              fileList => {
                _getFileList(fileList, 'qrCode');
              }
            "
          >
          </j-image-upload>
        </a-form-item>
        <a-form-item label=" ">
          <a-button type="primary" @click="tableDia = true">
            新增
          </a-button>
          <a-table
            :columns="columns"
            :dataSource="selectedList"
            :pagination="false"
            :loading="loading"
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="goDetails(record)">查看</a>

              <a-divider type="vertical" />
              <a @click="goEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="delTable(record)">删除</a>
            </span>
          </a-table>
        </a-form-item>
      </a-form>
    </a-spin>
    <a-modal
      v-model="tableDia"
      title="新增"
      ok-text="确认"
      cancel-text="取消"
      width="700px"
      @ok="tableDia = false"
    >
      <a-table
        :columns="diaColum"
        :dataSource="data"
        :pagination="false"
        :row-selection="rowSelection"
      >
        <a slot="name" slot-scope="text">{{ text }}</a>
      </a-table>
    </a-modal>
    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit()" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import { getFileIOByMediaId } from '@/api/api';
const diaColum = [
  {
    title: '产品名称',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '产品代码',
    dataIndex: 'age',
    key: 'age',
    width: 80
  },
  {
    title: '产品简称',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true
  },
  {
    title: '细分类型',
    dataIndex: 'address',
    key: 'address 2',
    ellipsis: true
  },
  {
    title: '估值套账账号',
    dataIndex: 'address',
    key: 'address 3',
    ellipsis: true
  }
];

const data = [
  {
    key: '1',
    name: '西****长混',
    age: '000006',
    address: '西*混合',
    code: '131514'
  },
  {
    key: '2',
    name: '西****短债',
    age: '006806',
    address: '西*债A',
    code: '131514'
  },
  {
    key: '3',
    name: '西****长混',
    age: '000006',
    address: '西*混合',
    code: '131514'
  }
];
export default {
  name: 'numberModal',
  components: {
    JImageUpload
  },
  props: {
    saveData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      selectedList: [],
      data,
      diaColum,
      view: {
        name: '',
        duties: '',
        certificate: [],
        investment: '',
        visible: false
      },
      visible: false,
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      disableSubmit: false,
      title: '新增',
      tableDia: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      fileList: [],
      selectData: [
        {
          id: '1e03daddb84e479e9f0fe57bf36c7386',
          name: '张*张'
        },
        {
          id: '8f3292c9c479bbafe0530100007fbb11',
          name: '徐*徐'
        },
        {
          id: '8f3292c9c47cbbafe0530100007fbb11',
          name: '郑*晓'
        },
        {
          id: '8f3292c9c486bbafe0530100007fbb11',
          name: '沈*沈'
        },
        {
          id: '8f3292c9c48bbbafe0530100007fbb11',
          name: '林*林'
        },
        {
          id: '8f3292c9c474bbafe0530100007fbb11',
          name: '王*王'
        },
        {
          id: '8f3292c9c49cbbafe0530100007fbb11',
          name: '陈*晔'
        }
      ],
      columns: [
        {
          title: '产品名称',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'age'
        },
        {
          title: '产品简称',
          align: 'center',
          dataIndex: 'address'
        },
        {
          title: '细分类型',
          align: 'center',
          dataIndex: 'type'
        },
        {
          title: '估值套账账号',
          align: 'center',
          dataIndex: 'code'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      dataList: [],
      selectedRowKeys: [],
      loading: false
    };
  },
  // inject: ['reload'],
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectedList = selectedRows;
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    delTable(record) {
      console.log(record);
      let key = record.key;
      this.selectedList.map((item, index) => {
        if (item.key == key) {
          this.selectedList.splice(index, 1);
        }
      });
    },
    //窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    add() {
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
      this.disableSubmit = false;
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    },

    _getFileList(fileList, flag) {
      console.log(fileList, flag);
      if (fileList.length > 0 && fileList) {
        let mediaId = fileList[fileList.length - 1].response.result.mediaId;
        getFileIOByMediaId({ mediaId }).then(res => {
          if (res.success) {
            this.avatar_mediaid = process.env.VUE_APP_CMS_MINIOURL + res.result;
            console.log(this.avatar_mediaid);
            this.form.setFieldsValue({
              [flag]: this.avatar_mediaid
            });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    onSelectChange() {},
    handleSubmit() {
      let that = this;
      console.log(this.view);
      console.log(this.fileList);
      let obj = {};
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = false;
          let formData = Object.assign(values, that.model);
          obj = {
            ...this.view,
            portrait: formData.portrait,
            qrCode: formData.qrCode
          };
          console.log('formData', formData);
        }
      });
      this.visible = false;

      if (
        obj.name == '' &&
        obj.duties == '' &&
        obj.certificate.length == 0 &&
        obj.investment == '' &&
        !obj.portrait &&
        !obj.qrCode
      ) {
        obj = {};
      }
      this.$emit('saveData', obj);
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
